<template>
  <!-- ////////// SECTION ABOUT DAVE ////////// -->
  <section id="about-section">
    <!-- CITY TOP -->
    <div class="city-wrapper">
      <div class="city"><!-- City BG Image Here --></div>
      <div class="city-bottom">
        <span class="copyright">
          &copy; {{ currentYear }} <a href="https://webdevdave.com">Web Dev Dave</a> - All rights reserved
        </span>
      </div>
    </div>

    <div id="about" class="about-wrapper">
      <!-- <h1>About Dave</h1> -->
      <main class="about">
        <h1>The Man. The Myth. The Dave.</h1>
        <!-- <img class="evolution" src="../assets/evolution.png"> -->
        <div class="photos">
          <div class="dave-headshot"><img src="../assets/dave-headshot.png" alt="dave headshot"></div>
          <div class="dave-family"><img src="../assets/dave-family.png" alt="dave family"></div>
        </div>
        <div class="story">
          <div class="f1">
            <!-- <h2>
              Creating websites for over 15 years and still loving every minute of it!
            </h2> -->
            <h2 class="fade-in right-slide">
              The entire process of going from concept to release and gather user's feedback makes me smile everyday!
            </h2>
          </div>
          <div class="f2">
            <p>
              <span class="intro-text">Hi, I'm Dave, an award winning web designer / developer with a knack for balancing the 
                big picture with the small details!</span>
            </p>
            <p>
              I made this site to showcase some of my work, as well as 
              give a dab of background about myself... welcome to my little corner of the web!
            </p>
            <p>
              Throughout my years as a <em>web guy</em>, I have gained invaluable skills that are suited 
              to a wide range of company needs, including front and back-end web development, UI / UX design, 
              brand development, video editing, photography, traditional 
              print design... and more!
            </p>
            <p>
              I strive to create sites that invoke the passion behind your organization, 
              using the latest development principles and techniques, 
              while being search engine friendly and adhering to best SEO practices.
            </p>
            <p>
              To find out more about what I can do for you, please, browse around, take a peek at my portfolio... get inspired! 
              if you'd like to work together, you can always get ahold of me via the 
              <a href="#contact">contact section</a> at the bottom of the page.
            </p>
            <p class="float-left">
              I look forward to working with you!
            </p>
            <img class="sig" src="../assets/sig.png" alt="Dave">
          </div>
        </div>
        
      </main>
    </div>
  </section>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
//ABOUT DAVE ///////////////

section#about-section {
  margin-top: calc(100vh - 159px);
  // min-height: calc(100vh + 159px);
  // min-height: calc(100vh + 136px);
  min-height: calc(100vh + 147px);
  .city-wrapper {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    .city {
      height: 79px;
      background: url("../assets/city.png") no-repeat top center;
    }
    .city-bottom {
      background: $almost-black;
      color: white;
      padding: 40px 20px 20px 20px;
      text-align: center;
      .copyright {
        font-size: 1.25rem;
        a {
          text-decoration: none;
          color: white;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .about-wrapper {
    background-color: $almost-black;
    // min-height: calc(100vh - 23px);

    // prettier-ignore
    background: 
                // url("../assets/halftone-orange.png") repeat-x center bottom,
                // url("../assets/almost-black-gradient.png") repeat-x center top,
                linear-gradient(to bottom, $almost-black 0%,lighten($almost-black, 8%) 100%);

    flex: 1;
    /* .dave-photo-frame {
      flex: 0.95;
      .dave-photo {
        margin-top: -50px;
      }
    } */
    h1 {
      margin-bottom: 0;
    }
    .photos {
      display: flex;
      margin-bottom: 20px;
      .dave-headshot {
        margin-top: -10px;
      }
      .dave-family {
        padding-top: 75px;
        margin-left: -30px;
      }
      @include tablet-down {
        .dave-family {
          padding-top: 40px;
          margin-left: -20px;
        }
      }
      @include phone-down {
        flex-direction: column;
        margin-bottom: 0;
        .dave-headshot {
          // margin-top: -15px;
          margin: -10px auto 0 auto;
          width: 90%;
        }
        .dave-family {
          display: none;
        }
      }
    }
    .story {
      display: grid;
      grid-template-columns: 1.15fr 1.85fr;
      gap: 20px;
      line-height: 1.3;
      h2 {
        font-size: 3rem;
        font-weight: 300;
      }
      a {
        color: $dark-grey;
        text-decoration: none;
        &:hover {
          color: white;
        }
      }
      .sig {
        float: right;
      }
      @include tablet-down {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
